import React from 'react';

interface CustomErrorBoundaryProps {
    render: (error: Error | null) => React.ReactNode;
    children?: React.ReactNode;
    resetKey?: string | number;
}

export class CustomErrorBoundary extends React.Component<CustomErrorBoundaryProps, { error: Error | null }> {
    constructor(props: CustomErrorBoundaryProps) {
        super(props);

        this.state = {
            error: null
        };
    }

    static getDerivedStateFromError(error: any) {
        return { error };
    }

    componentDidUpdate(previousProps: CustomErrorBoundaryProps) {
        if (this.state.error && previousProps.resetKey !== this.props.resetKey) {
            this.setState({ error: null });
        }
    }

    render() {
        if (this.state.error) {
            return this.props.render(this.state.error);
        }

        return this.props.children;
    }
}
